import React, { useEffect, useState, useRef } from "react";
import { Dropdown, DropdownToggle, DropdownMenu } from "reactstrap";
import TimeFrameTabContent from "./timeFrameTabContent";
import TimeFrameNavTab from "./timeFrameNavTab";
const DefaultTab = "v-pillstimeframe-monthly";
const Tabs = {
  "v-pillstimeframe-monthly": "monthly",
  "v-pillstimeframe-weekly": "weekly",
  "v-pillstimeframe-daily": "daily",
};
const TimeFrame = ({
  workWeeksAllList,
  getFrameData,
  currentFrameData,
  onApplyFrameData,
  isMonthOnly,
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [activeTab, setActiveTab] = useState(DefaultTab);
  const [activeTime, setActiveTime] = useState({});
  const isInitialized = useRef(false);
  const toggleTab = (tab) => {
    if (activeTab === tab) return;

    setActiveTab(tab);

    // Filter workWeeksAllList based on tab type
    const selectedType = Tabs[tab];

    const filteredList = workWeeksAllList.filter(
      (item) => item.typeofrecord?.toLowerCase() === selectedType,
    );

    if (filteredList.length > 0) {
      setActiveTime(filteredList[0]);
    }
  };
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const onApplySelection = (frameData) => {
    setActiveTime(frameData);

    onApplyFrameData({
      frameData,
      type: Tabs[activeTab],
    });
    toggle();
  };
  useEffect(() => {
    if (!workWeeksAllList?.length) return;

    //  If URL/Redux frame exists → ALWAYS apply it
    if (currentFrameData?.frameData && currentFrameData?.type) {
      setActiveTime(currentFrameData.frameData);

      const activeType = Object.keys(Tabs).find(
        (key) => Tabs[key] === currentFrameData.type,
      );

      if (activeType) {
        setActiveTab(activeType);
      }

      return;
    }

    //  If nothing selected yet → apply default
    if (!activeTime?.transdate) {
      const defaultTimeframe = workWeeksAllList[0];
      setActiveTime(defaultTimeframe);

      getFrameData({
        frameData: defaultTimeframe,
        type: Tabs[DefaultTab],
      });
    }
  }, [workWeeksAllList, currentFrameData]);

  // useEffect(() => {
  //   if (workWeeksAllList?.length > 0) {
  //     const DefaultTimeframe = workWeeksAllList[0];
  //     if (currentFrameData) {
  //       setActiveTime(currentFrameData?.frameData);
  //       const activeType = Object.keys(Tabs).find(
  //         (key) => Tabs[key] === currentFrameData?.type,
  //       );
  //       setActiveTab(activeType);
  //     } else {
  //       setActiveTime(DefaultTimeframe);
  //       getFrameData({
  //         frameData: DefaultTimeframe,
  //         type: Tabs[DefaultTab],
  //       });
  //     }
  //   }
  // }, [workWeeksAllList]);

  // useEffect(() => {
  //   if (currentFrameData) {
  //     setActiveTime(currentFrameData?.frameData);
  //     const activeType = Object.keys(Tabs).find(
  //       (key) => Tabs[key] === currentFrameData?.type,
  //     );
  //     setActiveTab(activeType);
  //   }
  // }, [currentFrameData]);

  return (
    <div className="dropdown" id="time_frame_dropdown">
      <Dropdown isOpen={dropdownOpen} toggle={toggle}>
        <DropdownToggle
          id="current_date"
          className="form-select"
          data-toggle="dropdown"
          tag="span"
        >
          {activeTime.displayname}
        </DropdownToggle>
        <DropdownMenu className="timeframe_selection">
          <div className="d-flex space-between align-start timeframe-scrollable">
            <div className="border-right border-transaprent">
              <TimeFrameNavTab
                activeTab={activeTab}
                toggleTab={toggleTab}
                isMonthOnly={isMonthOnly}
              />
            </div>
            <div className="border-left">
              <TimeFrameTabContent
                activeTab={activeTab}
                defaultActiveTime={activeTime}
                workWeeksAllList={workWeeksAllList}
                applyAction={onApplySelection}
                cancelAction={toggle}
              />
            </div>
          </div>
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};

export default TimeFrame;
